import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Table,
} from "reactstrap";
import { BiSearchAlt2 } from "react-icons/bi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { GrAddCircle, GrEdit } from "react-icons/gr";
import { getData } from "../../../api/method";
import Pagination from "../../pagination";

function TableBrand({ toggleAdd, getBrandByEdit, getBrandByDel }) {
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);

  const getBrand = async () => {
    try {
      const result = await getData("/api/Brand");
      setData(result.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getBrand();
  }, [data]);

  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(12);

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = data.slice(indexOfFirstData, indexOfLastData);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="d-flex align-items-center line_border--admin">
        <BiSearchAlt2 className="t-grey ms-2" />

        <Input
          className="border-0"
          placeholder="Enter you keyword..."
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="pt-4">
        <div className="d-flex justify-content-between pb-4">
          <Button
            className="btn_add fs-20 d-flex align-items-center"
            onClick={toggleAdd}
          >
            <GrAddCircle className="me-2" />
            Add
          </Button>
        </div>

        <Table className="table_admin">
          <thead>
            <tr className="fw-bold">
              <th className="table_c_stt">#</th>
              <th className="table_c_trademark">Brand</th>
              <th className="table_c_act" colSpan={2}></th>
            </tr>
          </thead>
          <tbody>
            {currentData
              ?.filter((item) => {
                if (search === "") {
                  return item;
                } else if (
                  item.name.toLowerCase().includes(search.toLowerCase())
                ) {
                  return item;
                }
              })
              .map((item, index) => (
                <tr key={index}>
                  <td className="table_c_stt">{index}</td>
                  <td className="table_c_trademark t-capitalize">
                    {item.name}
                  </td>
                  <td
                    className="table_c_act_1"
                    onClick={() => getBrandByEdit(item.id)}
                  >
                    <GrEdit className="fs-4" />
                  </td>
                  <td
                    className="table_c_act_2"
                    onClick={() => getBrandByDel(item.id)}
                  >
                    <RiDeleteBin6Line className="fs-4" />
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>

        <Pagination
          paginate={paginate}
          postsPerPage={dataPerPage}
          totalPosts={data.length}
        />
      </div>
    </>
  );
}

export default TableBrand;
